import React from "react";
import { Divider } from "../../../../../components/core/Divider/Divider";
import { StyledProfileDetail } from "../Resume.styled";
import { IconManager } from "../../../../../components/core/IconManager/IconManager";
import {
  CollaboratorInfo,
  FontWeightEnum,
  IconSizeEnum,
} from "../../../../../types/AppTypes";
import { theme } from "../../../../../constants/StyledComponents";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import {
  COMPETENCE_CENTER_LABEL,
  EMPTY_STRING,
  IN_ABSTRACT_LABEL,
  EXPERIENCE_LABEL,
  PRACTICE_LABEL,
} from "../../../../../constants/Dictionary";
import {
  findCCById,
  findPracticeById,
} from "../../../../../utils/orgFunctions.utils";
import { useAppSelector } from "../../../../../hooks/store.hook";
import { ReactComponent as PracticeIcon } from "../../../../../icons/practice.svg";
import { ReactComponent as CompetenceIcon } from "../../../../../icons/competence.svg";
import { ReactComponent as EperienceIcon } from "../../../../../icons/briefcase.svg";
import { ReactComponent as FileCheckIcon } from "../../../../../icons/fileCheck.svg";
import { CollaboratorResume } from "../../../../../types/api/collaborators.type";
import { StyledCollaboratorExperience } from "./CollaboratorExperience.styled";
import { getYearsAndMonths } from "../../../../../utils/date/date.utils";

export const CollaboratorExperience = ({
  collaborator,
  data,
  isComparison = false,
}: {
  collaborator: CollaboratorInfo;
  data: CollaboratorResume | null;
  isComparison?: boolean;
}) => {
  const { orgSettings } = useAppSelector((state) => state.config);

  return (
    <StyledCollaboratorExperience $isComparison={isComparison}>
      {!isComparison && (
        <>
          <div>
            <StyledProfileDetail>
              <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
                <PracticeIcon />
              </IconManager>
              <div>
                <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
                  {PRACTICE_LABEL}
                </BodyTyp>
                <BodyTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
                  <>
                    {collaborator
                      ? findPracticeById(
                          orgSettings.areaList.all,
                          collaborator.practice,
                        )?.name
                      : EMPTY_STRING}
                  </>
                </BodyTyp>
              </div>
            </StyledProfileDetail>
            <StyledProfileDetail>
              <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
                <CompetenceIcon />
              </IconManager>
              <div>
                <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
                  {COMPETENCE_CENTER_LABEL}
                </BodyTyp>
                <BodyTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
                  <>
                    {collaborator
                      ? findCCById(orgSettings.areaList.all, collaborator.cc)
                          ?.name
                      : EMPTY_STRING}
                  </>
                </BodyTyp>
              </div>
            </StyledProfileDetail>
          </div>
          <Divider />
        </>
      )}
      <div>
        {isComparison && (
          <StyledProfileDetail>
            <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
              <CompetenceIcon />
            </IconManager>
            <div>
              <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
                {COMPETENCE_CENTER_LABEL}
              </BodyTyp>
              <BodyTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
                <>
                  {collaborator
                    ? findCCById(orgSettings.areaList.all, collaborator.cc)
                        ?.name
                    : EMPTY_STRING}
                </>
              </BodyTyp>
            </div>
          </StyledProfileDetail>
        )}
        <StyledProfileDetail>
          <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
            <EperienceIcon />
          </IconManager>
          <div>
            <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
              {EXPERIENCE_LABEL}
            </BodyTyp>
            <BodyTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
              {data?.collaboratorDetail.totalExperienceMonths
                ? getYearsAndMonths(
                    data?.collaboratorDetail.totalExperienceMonths,
                  )
                : EMPTY_STRING}
            </BodyTyp>
          </div>
        </StyledProfileDetail>
        <StyledProfileDetail>
          <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
            <FileCheckIcon />
          </IconManager>
          <div>
            <BodyTyp variant="3" fontWeight={FontWeightEnum.REGULAR}>
              {IN_ABSTRACT_LABEL}
            </BodyTyp>
            <BodyTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
              {data?.collaboratorDetail.companyExperienceMonths
                ? getYearsAndMonths(
                    data?.collaboratorDetail.companyExperienceMonths,
                  )
                : EMPTY_STRING}
            </BodyTyp>
          </div>
        </StyledProfileDetail>
      </div>
    </StyledCollaboratorExperience>
  );
};
